import { useShowContext } from 'framework/show';
import { ControlledList, DataGridLayout, TableBodyWithGrouping } from 'framework/list';
import DocuSignRecipientsBox from './DocuSignRecipientsBox';
import { Typography } from '@mui/material';
import { BadgeField, FullDateField, TextField } from 'framework/ui/field';
import DocuSignEnvelopeStatusBadge from './badge/DocuSignEnvelopeStatusBadge';
import { ArtifactStorageOneFileLink } from 'domain/shared/artifactStorage';

const COUNT_TABLE_TD = 3;

interface DocuSignEnvelopeBoxProps {
  source: string;
}

const DocuSignEnvelopeBox = ({ source }: DocuSignEnvelopeBoxProps) => {
  const { data: showData } = useShowContext();
  const envelopes = showData.getValueBySource(source);
  const totalElements = envelopes ? envelopes.length : 0;

  return (
    <ControlledList data={{ items: envelopes, totalElements, totalPages: 1 }}>
      <DataGridLayout
        showTotal={false}
        tableBodyComponent={(props: any) => (
          <TableBodyWithGrouping
            {...props}
            childrenSource="recipients.signers"
            toggleSource="artifactStorageFileId"
            CustomChildTemplate={
              <tr>
                <td colSpan={COUNT_TABLE_TD}>
                  <Typography variant="h6" color="primary" mb={0.625} mt={1.25}>
                    Signers details
                  </Typography>
                  <DocuSignRecipientsBox source="recipients.signers" />
                </td>
              </tr>
            }
          />
        )}
      >
        <ArtifactStorageOneFileLink source="artifactStorageFileId" isInternal={false} label="ID link" />
        <TextField source="envelopeType" label="Type" />
        <BadgeField badges={[<DocuSignEnvelopeStatusBadge source="envelopeStatus" />]} label="Status" width="25%" />
        <FullDateField source="updatedAt" label="Updated at" width="25%" />
      </DataGridLayout>
    </ControlledList>
  );
};

export default DocuSignEnvelopeBox;
